import React from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { GetRegion, PLAYER_SEGMENT, SUPPORTED_STREAM } from 'constants.js';
import get from 'lodash/get';
import * as CARROUSEL_ACTIONS from 'action-creators/carousel';
import * as TOOLTIP_ACTIONS from 'action-creators/tooltip';
import * as actions from 'action-creators/metrics';
import Metrics from 'utils/Metrics';
import * as actionsModal from 'actions/response';
import Utils from 'utils/Utils';
import HTMLDECODE from 'utils/htmlDecode';
import { converter } from 'helpers/converter';
import { getDefaultChannelFromEpg } from 'containers/Header/selectors';
import { paywayLinealChannels } from 'services/api/payway/linealChannels';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { checkIfChannelIsBlocked } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import * as constants from './constants';
import BtnCardFavorite from '../card/BtnCardFavorite';
import PosterFormatType from '../posters/PosterFormatType';
import PosterTitle from '../posters/PosterTitle';
import placeHolders from './utils/placeHolders';
import ContentItemRecord from '../content-item-recording/ContentItemRecord';
import ContentItem from '../content-item/ContentItem';
import Carousel from './Carousel';
import { createAndShowTooltip, deleteTooltip } from '../../actions/NewTooltip';
import {
  ACTIONS,
  pushEvent,
  pushGTMEvent,
} from 'containers/Player/utils/analytics';
import {
  events,
  category,
  Actions,
} from 'containers/MundialViews/utils/analytics';
import { setRecordingToPlay } from 'containers/Player/actions/recordings/recordings.actions';
import getActualScreen from 'containers/Player/utils/getActualScreen';
import deleteSymbols from '../../utils/deleteSymbols';
import { fetchPaywayLinealChannels } from 'action-creators/infinite';
import { getPurchaseButtonInfo } from 'action-creators/payway/purchaseButtonInfo';
import { showEpgTransactions } from 'containers/Player/actions/epgTransactions/epgTransactions.actions';
import { getContentListV1 } from 'utils/homologacion/homologacion';

export class CarouselClaro extends React.Component {
  constructor(props) {
    super(props);
    this.__id = Utils.createId();
    const calcSlides = parseInt(
      Math.max(document.documentElement.clientWidth, window.innerWidth || 0) /
        190,
      10,
    );
    this.data = [];
    this.state = {
      firstTouch: false,
      placeholder: placeHolders.getManyPlaceHolders(),
      // enviamos el calculo de los slides necesarios para el viewport
      incrementalSlide: calcSlides + 1,
      emptyAdds: [],
    };
    this.handleClick = this.handleClick.bind(this);
    this.redirectRecording = this.redirectRecording.bind(this);
  }

  proccessRoute() {
    const { location } = this.props;
    if (location) {
      const route = location.pathname;
      const r = route.split('/');
      return r[2];
    }
  }

  proccessIdx(id) {
    const i = id.split('_');
    if (i.length > 1) return i[1];
    return id;
  }

  componentWillUnmount() {
    this.props.cleanToolTipData();
  }

  proccessTag(data) {
    const hasTitle = g => g.title !== undefined;
    const hasFormatTypes = g => g.format_types !== undefined;

    if (hasTitle(data) && !hasFormatTypes(data)) {
      return `${data.title} -`;
    }
    if (!hasTitle(data) && hasFormatTypes(data)) {
      return `${data.format_types} -`;
    }
    if (hasTitle(data) && hasFormatTypes(data)) {
      return `${data.format_types}-${data.title} -`;
    }
    return '';
  }

  async handleClick(e, redirectLink, g, idx, value) {
    const {
      isRecording,
      name,
      paqs,
      showModal,
      isPlayAndGo,
      setMetricsEvent,
      isMyList,
      isBuyList,
      deleteTooltip,
      title,
    } = this.props;
    deleteTooltip();

    if (g.section === 'mundial2022') {
      pushEvent(
        events.CARRUSELES,
        category.CARRUSELES,
        Actions.SUPERDESTACADO,
        g?.section,
      );
    }
    if (isRecording) {
      return null;
    }
    const hasTitle = this.proccessTag(g);
    const val = value;
    let route = this.proccessRoute();
    let tag;

    // Obtain values to event metrics
    const path = this.proccessRoute();
    const section = getActualScreen(path);
    const eventInfo = {
      event: 'select_content',
      content_section: section.replace('sa', ''),
      content_list: title
        ? deleteSymbols(title).toLowerCase()
        : deleteSymbols(name)
            .replace('-', ' ')
            .toLowerCase(),
      content_id: g.id ? g.id : g.group_id,
      content_name: g.title,
    };

    if (redirectLink.action) {
      // Select TV Event
      pushGTMEvent({ ...eventInfo, content_type: 'canal tv' });

      e.preventDefault();
      e.stopPropagation();
      if (redirectLink.action.type === constants.OPEN_TYPE) {
        return window.open(redirectLink.action.source);
      }

      if (redirectLink.action.type === constants.LOCATION_TYPE) {
        window.location = redirectLink.action.source;
        return window.location;
      }

      if (
        redirectLink.action.type === constants.LOCATIONTV_TYPE &&
        name !== constants.PORVER
      ) {
        const channelId =
        redirectLink.action.channel.group_id ||
        redirectLink.action.channel.id;
        const channelsAvail =paqs?.[channelId]?.live?.canPlay === 1;
        const channelsEmpty = channelsAvail.length < 1;
        const thirdProviderModal = {
          modalType: constants.SUSCRIPTION_CHANNEL,
          props: {
            message: constants.MODAL_FOX,
            item: redirectLink.action.channel,
          },
        };

 
        if (channelsEmpty || !channelsAvail) {
          showModal(thirdProviderModal);
          return null;
        }
        return this.props.checkIfChannelIsBlocked({
          group_id: channelId,
          onSuccess: () => {
            return this.props.navigate(
              `/${GetRegion()}${PLAYER_SEGMENT}${channelId}`,
            );
          },
        });
        /* window.location = redirectLink.action.source;
        return window.location; */
      }
    }

    const processIdx = this.proccessIdx(idx);

    if (route.indexOf(constants.INDEX_SOCIAL) !== -1) {
      route = constants.SOCIALIZATION;
    }

    tag = `${hasTitle} ${processIdx} | ${val}`;

    if (hasTitle === 'null- -') {
      tag = `ESP ${processIdx} | ${val}`;
    }

    let typeevent = constants.CAROUSEL;

    if (isPlayAndGo) {
      typeevent = 'Top menu';
      tag = `${route}${(g.code && `/${g.code}`) || ''}`;
      route = 'click';
    }
    const params = {
      event: `${typeevent}`,
      eventLabel: tag,
      eventAction: `${route}`,
    };
    const m = new Metrics(params);
    const tagManager = m.setMetricsQuick('common');
    if (!(tagManager?.tagManager?.eventLabel === 'ESP 0 | Superdestacado')) {
      setMetricsEvent(tagManager);

      setMetricsEvent({ type: 'executor', success: true });
    }

    if (!redirectLink.redirectUrl) {
      if (redirectLink.action) window.location = redirectLink.action.source;
    } else if (g.isGuideChannels) {
      const groupId = this.props.defaultChannel;
      this.props.fetchLinealChannel();
      const channels = Object.keys(this.props.linealChannels || []) || [];
      const linealChannel = this.props.linealChannels;
      const epgLineUp = this.props?.epgLineUp;
      //LOS CANALES POR DEFAULT
      const isChannelDefaultFromEpgLineup = epgLineUp?.find(
        channel => channel?.default === true,
      );
      const channelCanPlayFromEpgLineup = epgLineUp.find(channel => {
        if (linealChannel?.[channel?.group_id]?.live?.canPlay === 1)
          return channel;
      });
      const defaultLiveChannel = localStorage.getItem('defaultLiveChannel');

      const isInUserChannels = channels.indexOf(defaultLiveChannel) > -1;
      //LOGICA CUANDO EL USARIO YA HA VISTO UN CANAL
      if (defaultLiveChannel) {
        const canPlayLiveChannelLastSeen =
          linealChannel?.[defaultLiveChannel]?.live?.canPlay === 1;
        if (canPlayLiveChannelLastSeen) {
          return this.props.checkIfChannelIsBlocked({
            group_id: defaultLiveChannel,
            onSuccess: () =>
              this.props.navigate(
                `/${GetRegion()}${PLAYER_SEGMENT}${defaultLiveChannel}`,
              ),
          });
        }
        const infoLastSeenChannel = epgLineUp?.find(
          channel => channel?.group_id === defaultLiveChannel,
        );
        this.props.getPurchaseButtonInfo({ group_id: defaultLiveChannel });
        this.props.showEpgTransactions(infoLastSeenChannel?.group?.common);
        return localStorage.removeItem('defaultLiveChannel');
      }
      //LOGICA CUANDO SE ENCONTRO UN CANAL CON DEFAULT TRUE QUE SE PUEDE REPRODUCIR DE LA LINEUP
      if (
        isChannelDefaultFromEpgLineup &&
        linealChannel?.[isChannelDefaultFromEpgLineup?.group_id]?.live
          ?.canPlay === 1
      ) {
        return this.props.checkIfChannelIsBlocked({
          group_id: groupId,
          onSuccess: () =>
          this.props.navigate(
              `/${GetRegion()}${PLAYER_SEGMENT}${isChannelDefaultFromEpgLineup?.group_id}`,
            ),
        });
      }
      //LOGICA PARA REPRODUCIR UN CANAL DE LA LINEUP CON CANPLAY 1
      return this.props.checkIfChannelIsBlocked({
        group_id: groupId,
        onSuccess: () =>
        this.props.navigate(`/${GetRegion()}${PLAYER_SEGMENT}${channelCanPlayFromEpgLineup?.group_id}`),
      });
    } else {
      const urlRedirect = redirectLink.redirectUrl;
      this.props.navigate(urlRedirect, {
        state: { eventInfo },
      });
    }
  }

  onImageError(e) {
    e.target.src = constants.URL_IMAGE_ERROR;
  }

  onHover(event, tooltipData = {}, __id, isIngested) {
    const { isRecording, deleteTooltip, createAndShowTooltip } = this.props;
    if (
      this.isHighlight ||
      getContentListV1?.IsLive(tooltipData) ||
      (isRecording && !isIngested) ||
      !tooltipData.title ||
      event.currentTarget == window.lastTooltipTarget
    ) {
      return null;
    }
    if (window.mouseLeaveTooltipTimeout) {
      clearTimeout(window.mouseLeaveTooltipTimeout);
    }
    deleteTooltip();
    createAndShowTooltip({ ...tooltipData }, { ...event });
    window.lastTooltipTarget = event.currentTarget;
  }

  removeSlide(g, index) {
    this.setState({ emptyAdds: [...this.state.emptyAdds, index] });
  }

  getUserSubscriptions = () => {
    const { user } = this.props;
    return Object.keys((user && user.subscriptions) || {}).map(
      k => user && user.subscriptions[k] && k,
    );
  };

  redirectRecording(e, redirectLink, actionRecording, item) {
    const { translations, showModal } = this.props;
    if (redirectLink !== false && redirectLink.redirectUrl) {
      const deviceSO = Utils.getDeviceOS();
      let url;
      SUPPORTED_STREAM[deviceSO].forEach(value => {
        if (actionRecording.play[value]) {
          url = actionRecording.play[value];
        }
      });

      const recordingData = {
        item,
        url,
      };

      this.props.setRecordingToPlay(recordingData, () => {
        this.props.navigate(
          `/${GetRegion()}/watch/${redirectLink.redirectUrl}`,
        );
      });
    } else if (redirectLink !== false && !redirectLink.redirectUrl) {
      const titleBold = converter.convertApa(
        translations,
        constants.UNSUPPORTED_PLAY_RECORDING_TITLE_BOLD,
      );
      const title = converter.convertApa(
        translations,
        constants.UNSUPPORTED_PLAY_RECORDING_TITLE,
      );
      const msg = converter.convertApa(
        translations,
        constants.UNSUPPORTED_PLAY_RECORDING_MSG,
      );

      const modalType = {
        modalType: constants.ERROR_RECORDING,
        props: {
          titleBold,
          title,
          msg,
        },
      };
      showModal(modalType);
    }
  }

  mouseLeaveCarouselItem = e => {
    if (window.mouseOverTooltipTimeout) {
      clearTimeout(window.mouseOverTooltipTimeout);
    }
    window.mouseLeaveTooltipTimeout = setTimeout(() => {
      this.props.deleteTooltip();
      window.lastTooltipTarget = null;
    }, 500);
  };

  mouseLeaveCarouselItem = e => {
    window.mouseLeaveTooltipTimeout = setTimeout(() => {
      this.props.deleteTooltip();
      window.lastTooltipTarget = null;
    }, 500);
  };

  normalCarrousel(item, index) {
    const {
      user,
      config,
      imagesSize,
      isMyList,
      translations,
      name,
      isRecording,
      size,
      sizeAlt,
      isPlayAndGo,
      apaAssets,
      recordingList,
      title,
      progressBar,
      canPlay,
      isSeenList,
      type,
      metadata,
    } = this.props;
    const mainClass = '';
    const userType = Utils.userStatusParse(user);
    const urlPlayer = typeof config === 'object' ? config.urlPlayer : undefined;
    const enabledChannel = get(canPlay, [item.id, 'live.canPlay'], false) === 1;
    let isIngested = false;

    let footerMyList = null;

    if (isMyList || isSeenList) {
      footerMyList = (
        <div className="ToolTip-Buttons">
          <BtnCardFavorite
            user={user}
            translations={translations}
            group={item}
            isMyList
            isSeenList={isSeenList}
            name={name}
            index={index}
          />
        </div>
      );
    }
    if (name === 'Mis-programas-grabados') {
      isIngested = true;
    } else if (name === 'Por-grabar') {
      isIngested = false;
    }

    const __id = `${this.__id}_${index}_tooltip`;

    return (
      <div key={__id} className={mainClass}>
        <div className="row">
          <div className="image">
            <div
              className="item-wrapper"
              onMouseOver={e =>
                this.onHover.bind(this)(e, item, __id, isIngested)
              }
              onMouseLeave={this.mouseLeaveCarouselItem}
            >
              {isRecording ? (
                <ContentItemRecord
                  redirectRecording={this.redirectRecording}
                  size={size}
                  onImageError={this.onImageError}
                  item={item}
                  sizeAlt={sizeAlt}
                  isPlayAndGo={isPlayAndGo}
                  apaAssets={apaAssets}
                  isRecording={isRecording}
                  isHighlight={this.isHighlight}
                  userType={userType}
                  urlPlayer={urlPlayer}
                  recordingList={recordingList}
                  imagesSize={imagesSize}
                  name={name}
                  type={type}
                />
              ) : (
                <ContentItem
                  size={size}
                  onImageError={this.onImageError}
                  item={item}
                  sizeAlt={sizeAlt}
                  isPlayAndGo={isPlayAndGo}
                  apaAssets={apaAssets}
                  isHighlight={this.isHighlight}
                  userType={userType}
                  urlPlayer={urlPlayer}
                  imagesSize={imagesSize}
                  name={name}
                  title={title}
                  handleClick={this.handleClick}
                  id={__id}
                  isMyContents={isMyList}
                  progressBar={progressBar}
                  enabledChannel={enabledChannel}
                  type={type}
                />
              )}
              {footerMyList}
            </div>
          </div>
        </div>
      </div>
    );
  }

  recommendationDouble(item, index) {
    const { user, config, translations, name, size, type } = this.props;
    const mainClass = '';
    const userType = Utils.userStatusParse(user);
    const urlPlayer = typeof config === 'object' ? config.urlPlayer : undefined;

    const { seen } = item;
    const recommendations = item.recommendation;

    if (recommendations.length === 0) {
      return null;
    }

    const title = converter.convertApa(
      translations,
      constants.HOME_USER_RECOME2ONE_FIRST_TITLE,
    );
    const title2 = converter.convertApa(
      translations,
      constants.PREDICTSEARCH_SUGGEST_LABEL,
    );

    const seenGroupId = seen.group_id || seen.id;
    let redirectLinkSeen = {
      redirectUrl: `/${GetRegion()}/vcard/homeuser/${
        seen.title_uri
      }/${seenGroupId}`,
    };
    let redirectLinkRecommendation = {
      redirectUrl: `/${GetRegion()}/vcard/homeuser/${
        recommendations[0].title_uri
      }/${seenGroupId}`,
    };

    if (seen.id || seen.group_id || seen.type) {
      redirectLinkSeen = Utils.buildRedirect({
        content: seen,
        userType,
        urlPlayer,
      });
      redirectLinkRecommendation = Utils.buildRedirect({
        content: recommendations[0],
        userType,
        urlPlayer,
      });
    }

    return (
      <div key={index} className={mainClass}>
        <div
          className="item-wrapper carousel-double"
          onClick={e =>
            this.handleClick(e, redirectLinkSeen, item, index, title)
          }
        >
          {name === 'Recomendador-2' && (
            <div className="recomendando">
              <div className="item-1 pull-left">
                <div className="titulo-doble">
                  <h4
                    className="ng-binding"
                    dangerouslySetInnerHTML={{
                      __html: HTMLDECODE(title),
                    }}
                  />

                  <h4 className="mini-title">{seen.title}</h4>
                </div>
                <Link to={redirectLinkSeen.redirectUrl} className="item-img">
                  {seen.image_medium && (
                    <img
                      src={seen.image_medium}
                      width="134"
                      height="200"
                      alt=""
                    />
                  )}
                  <div className="item-format item-format-right carrouselrecommended" />
                  <span className="play">
                    {' '}
                    <i className="fa fa-play-circle-o" />
                  </span>
                  <PosterFormatType item={seen} />
                  <b className="fa fa-caret-right" />
                </Link>
              </div>
              <div className="item-2 pull-left popover-active">
                <h4
                  className="ng-binding"
                  dangerouslySetInnerHTML={{
                    __html: HTMLDECODE(title2),
                  }}
                />
                <Link to={redirectLinkRecommendation.redirectUrl}>
                  {recommendations[0].image_large && (
                    <div>
                      <img
                        src={recommendations[0].image_large}
                        width="350"
                        height="200"
                        alt=""
                      />
                      <PosterTitle resource={recommendations[0]} type={type} />
                    </div>
                  )}
                  <div className="item-format item-format-right carrouselrecommended" />
                  <span className="play">
                    {' '}
                    <i className="fa fa-play-circle-o" />
                  </span>
                  <PosterFormatType item={recommendations[0]} />
                </Link>
              </div>
            </div>
          )}

          {!name === 'Recomendador-1' && (
            <Link
              to={redirectLinkRecommendation.redirectUrl}
              className="item-img"
            >
              {item[size] && <img src={item[size]} alt="" />}
              <span className="play">
                <i className="fa fa-play-circle-o" />
              </span>
              <PosterFormatType item={item} />
              <PosterTitle resource={item} type={type} />
            </Link>
          )}
        </div>
      </div>
    );
  }

  setBackGround(index, isInit) {
    if (index && index > 0) {
      this.setState({ firstTouch: true });
    }

    if (this.isHighlight && this.data.length > 0 && this.data[0].type) {
      const active = true;
      let sourceData = '';

      if (isInit) {
        [sourceData] = this.data;
      } else {
        sourceData = this.data[index];
        // Reverse
        if (!sourceData) {
          [sourceData] = this.data;
        }
      }

      const source = sourceData.image_background;

      this.props.setBackGround({ source, active });
    }
  }

  getItems() {
    const { carrouselData, groups } = this.props;
    let groupsSliced;

    if (
      !this.state.firstTouch &&
      (!carrouselData || carrouselData.type !== 'Highlight')
    ) {
      const difference = groups.length - this.state.incrementalSlide;
      if (difference > 0) {
        const empties = groups
          .slice(this.state.incrementalSlide, groups.length - 3)
          .map(item => {
            const e = { ...item };
            delete e.image_large;
            delete e.image_medium;
            delete e.image_small;
            delete e.image_still;
            delete e.image_background;
            return e;
          });

        groupsSliced = [
          ...groups.slice(0, this.state.incrementalSlide),
          ...empties,
          ...groups.slice(groups.length - 3),
        ];
      } else {
        groupsSliced = groups.slice(0, this.state.incrementalSlide);
      }
    } else {
      groupsSliced = groups;
    }
    return groupsSliced.filter(
      (g, index) => this.state.emptyAdds.indexOf(index) === -1,
    );
  }

  renderContent(items) {
    const { recommendationDouble } = this.props;
    return items
      .map((item, index) => {
        if (recommendationDouble) {
          return this.recommendationDouble(item, index);
        }

        return this.normalCarrousel(item, index);
      })
      .filter(contentComponent => contentComponent);
  }

  render() {
    let cellAlign = 'left';
    let slideWidth = '';
    let slideHeight = 0;
    let autoplay = false;
    const customStyles = {};
    const {
      name,
      size,
      claroRecommendation,
      groups,
      scrollSlide,
      isPlayAndGo,
      type,
    } = this.props;

    switch (size) {
      case 'ext_eventimage_name':
        slideWidth = '290px';
        slideHeight = 163;
        break;

      case 'image_background':
        slideWidth = '1280px';
        slideHeight = 720;
        break;

      case 'image_highlight':
        this.isHighlight = true;
        slideWidth = '780px';
        slideHeight = 282;
        autoplay = true;
        cellAlign = 'center';
        break;

      case 'image_large':
        slideWidth = '680px';
        slideHeight = 251;
        if (claroRecommendation) {
          slideWidth = '450px';
        }
        break;

      case 'image_medium':
        slideWidth = '170px';
        slideHeight = 300;
        break;

      case 'image_small':
        slideWidth = '300px';
        slideHeight = 165;
        break;
      default:
        break;
    }

    if (name === 'Recomendador-1') {
      slideWidth = '590px';
      slideHeight = 254;
      customStyles.height = '200px !important';
      customStyles.width = '100% !important';
    }

    if (name === 'recomendador_2') {
      slideWidth = '350px';
    }

    if (!groups || groups.length === 0) {
      this.data = this.state.placeholder;
    } else if (groups.length > 0) {
      this.data = this.getItems();
    }

    if (name === 'porver') {
      slideWidth = '290px';
      slideHeight = 163;
    }
    if (isPlayAndGo) {
      slideWidth = '375px';
      slideHeight = 125;
    }

    return (
      <Carousel
        slidesToScroll={scrollSlide}
        cellSpacing={10}
        slideWidth={slideWidth}
        speed={200}
        wrapAround
        initialSlideHeight={slideHeight}
        autoplay={autoplay}
        cellAlign={cellAlign}
        data={index => this.setBackGround.bind(this)(index)}
        customStyles={customStyles}
        type={type}
        name={name}
        realSize={groups ? this.data.length : 0}
      >
        {this.renderContent(this.data)}
      </Carousel>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  config: state.config,
  translations: state.translations,
  apaAssets: state.asset,
  paqs: state?.linealChannel?.data,
  canPlay: state?.linealChannel?.data,
  recordingList: state.carousel.recordingList,
  newTooltip: state.newTooltip,
  defaultChannel: getDefaultChannelFromEpg(state),
  metadata: state.metadata,
  linealChannels: state.linealChannel?.data,
  epgLineUp: state?.EpgLineUp?.data,
});

const mapDispatchToProps = dispatch => ({
  setBackGround(options) {
    return dispatch(CARROUSEL_ACTIONS.setBackGround(options));
  },
  setMetricsEvent(options) {
    dispatch(actions.setMetricsEvent(options));
  },
  setTooltip(options) {
    return dispatch(TOOLTIP_ACTIONS.setToolTip(options));
  },
  cleanToolTipData() {
    return dispatch(TOOLTIP_ACTIONS.cleanToolTipData());
  },
  showModal(modal) {
    dispatch(actionsModal.showModal(modal));
  },
  createAndShowTooltip(tooltipData, eventData) {
    dispatch(createAndShowTooltip(tooltipData, { ...eventData }));
  },
  deleteTooltip() {
    dispatch(deleteTooltip());
  },
  checkIfChannelIsBlocked(params) {
    dispatch(checkIfChannelIsBlocked(params));
  },
  setRecordingToPlay(recordingData, cb) {
    dispatch(setRecordingToPlay(recordingData, cb));
  },
  fetchLinealChannel() {
    dispatch(fetchPaywayLinealChannels());
  },
  getPurchaseButtonInfo(params) {
    dispatch(getPurchaseButtonInfo(params));
  },
  showEpgTransactions(params) {
    dispatch(showEpgTransactions(params));
  },
});

CarouselClaro.propTypes = {
  imagesSize: PropTypes.object,
  scrollSlide: PropTypes.number,
  setBackGround: PropTypes.func,
  setMetricsEvent: PropTypes.func,
  setTooltip: PropTypes.func,
  canPlay: PropTypes.object,
  defaultChannel: PropTypes.string,
};

CarouselClaro.defaultProps = {
  imagesSize: {},
  scrollSlide: 1,
  setBackGround: a => a,
  setMetricsEvent: a => a,
  setTooltip: a => a,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CarouselClaro);
